export const TokenDialogTokenListHeader: React.FC<{
  tokenCount: number
  controls?: React.ReactNode
}> = ({ tokenCount, controls }) => {
  return (
    <div className="-mb-2 ml-1 flex flex-row items-center justify-between pr-4 text-xs text-t200">
      <p>{tokenCount} tokens</p>
      {controls && <div>{controls}</div>}
    </div>
  )
}
